import { Inline, Skeleton, Stack } from '@omnipresentgroup/design-system';

const TitleSkeleton = () => {
  return (
    <Inline h={32} align="center">
      <Skeleton height={20} width={300} />
    </Inline>
  );
};

const FieldSkeleton = () => {
  return (
    <Stack gap="4">
      <Inline h={24} align="center">
        <Skeleton height={16} width={200} />
      </Inline>
      <Skeleton height={40} />
    </Stack>
  );
};
export const DocumentFormSkeleton = () => {
  return (
    <Stack gap="32">
      <Stack gap="16">
        <TitleSkeleton />
        {Array.from({ length: 5 }, (_, index) => (
          <FieldSkeleton key={index} />
        ))}
      </Stack>
      <Stack gap="16">
        <TitleSkeleton />
        {Array.from({ length: 3 }, (_, index) => (
          <FieldSkeleton key={index} />
        ))}
      </Stack>
      <Stack gap="16">
        <TitleSkeleton />
        <Stack gap="4">
          <Inline h={24} align="center">
            <Skeleton height={16} width={200} />
          </Inline>
          {Array.from({ length: 3 }, (_, index) => (
            <Inline key={index} gap="8" h={24}>
              <Skeleton height={16} width={16} circle />
              <Skeleton height={16} width={30} />
            </Inline>
          ))}
        </Stack>
      </Stack>
      <Skeleton height={88} />
      <Inline justify="space-between">
        <Skeleton width={80} height={40} />
        <Skeleton width={80} height={40} />
      </Inline>
    </Stack>
  );
};
